import Vue from "vue";
import RelationSectionLinkedDetailView from "~/models/detailView/elements/relationSectionLinkedDetailView";
import { Constructor } from "../../../global/constructor";
import { DetailViewContentElementType } from "../../enums/detailViews/detailViewContentElementType";
import { ArrayHelper } from "../../helpers/arrayHelper";
import { ObjectHelper } from "../../helpers/objectHelper";
import { IContentElementContainer, ISortableContentElement } from "../../interfaces/contentManagementInterfaces";
import { Hash } from "../../interfaces/hashInterfaces";
import ElementHandler from "../../services/elementHandler";
import MappedPropertyLinkedDetailView from "../detailView/elements/mappedPropertyLinkedDetailview";
import TrackedModel from "../tracked/trackedModel";

interface IContentElementable<TContentElement> {
  rootModel: TrackedModel;
  content_elements: Hash<TContentElement>;
  _contentElementHandler: ElementHandler;
  _classKey: string;
}

export default function ContentElementable<TBase extends Constructor,
  TContentElement extends ISortableContentElement &
    TrackedModel,
  TContainer extends TrackedModel &
    IContentElementContainer<TContentElement> &
    TContentElement>(Base: TBase) {
  return class extends Base implements IContentElementable<TContentElement> {
    rootModel: TrackedModel;
    content_elements: Hash<TContentElement> = {};
    _contentElementHandler: ElementHandler;
    _classKey: string;

    get classKey(): string {
      return this._classKey;
    }

    get contentElementHandler(): ElementHandler {
      return this._contentElementHandler;
    }

    get contentElementsArray(): TContentElement[] {
      return ObjectHelper.toArray(this.content_elements)
        .sort((a, b) => a.sort_order - b.sort_order);
    }

    get hasContentElements(): boolean {
      return this.contentElementsArray.length > 0;
    }

    get lastContentElementInSortOrder(): TContentElement {
      return ArrayHelper.last(this.contentElementsArray);
    }

    initializeEmbedded(parent: TContainer | TContentElement, item: TContentElement | MappedPropertyLinkedDetailView | RelationSectionLinkedDetailView, position: number, json: object = {}, selectItem: boolean = true) {
      
      if (parent.content_type !== DetailViewContentElementType.Grid) {
        if (item.nameInParent !== "reference_path") {
          !(item instanceof MappedPropertyLinkedDetailView) && !(item instanceof RelationSectionLinkedDetailView) && item.elementHandler.updateElementPositions(parent, item, position);
        }
      }
      parent.trackCreationDeletion(item.client_id, null, item.asJson(), item);
      item.addToRepo();
      if (selectItem) {
        item.select();
      }

      Vue.set(parent[item.rootName], item.client_id, item);
      return item;
    }
  }
}